'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 *
 * Usage:
 *
 * ```Javascript
 * <SiteNavigationMenu menuType isActive>
 * 	{ Children }
 * </SiteNavigationMenu>
 * ```
 *
 * @extends {React.Component}
 * @property {String} menuType Defines whether to render the Navigation Menu as part of menu or subMenu.
 * @property {Boolean} isActive Renders the Navigation Menu as active
 */
class SiteNavigationMenu extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getClassName (isActive, menuType) {
    return classNames({
      [`SiteNavigation-${menuType}`]: true,
      'is-active': isActive
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { isActive, menuType } = this.props;
    const children = React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {menuType: menuType});
    });

    return (
      <ul className={this.getClassName(isActive, menuType)}>
        { children }
      </ul>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the SiteNavigationMenu component
 */
SiteNavigationMenu.propTypes = {
  isActive: React.PropTypes.bool,
  menuType: React.PropTypes.oneOf(['menu', 'subMenu'])
};

SiteNavigationMenu.defaultProps = {
  isActive: false,
  menuType: 'menu'
};

export default SiteNavigationMenu;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/siteNavigation/siteNavigationMenu.jsx